import React from 'react';
import PropTypes from 'prop-types';
import Textarea from './Textarea';
import {
  Input,
  FileInput,
  Select,
  SelectWrapper,
  FormLabel,
  Radio,
  SoundGroup,
  Checkbox,
  UserProfile,
  TimePickerStyle,
} from './styles';
import style from './styles';
import TimeField from 'react-simple-timefield';
import ReactAudioPlayer from 'react-audio-player';
import Toggle from 'react-toggle';

const propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  round: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onFocus: PropTypes.func,
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  componentClass: PropTypes.oneOf([
    'select',
    'radio',
    'checkbox',
    'file',
    'textarea',
    'input',
    'timePicker',
    'audioPlayer',
    'audioPlayer30',
    'audioStreamer25',
    'audioStreamer',
    'toggle',
    'user_file',
    'inputIcon',
  ]),
};

const defaultProps = {
  componentClass: 'input',
  required: false,
  defaultChecked: false,
  disabled: false,
};

const renderElement = (Element, attributes, type, child) => {
  const { children, ...att } = attributes;
  return (
    <FormLabel key={attributes.key ? attributes.key : null}>
      <Element {...att} type={type} />
      <span style={{ display: "inline-flex" }}>
        {children && '\u00a0\u00a0'}
        {children}
      </span>
    </FormLabel>
  );
};

class FormControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }
  renderFileName(selectedFile) {
    if (selectedFile && !this.props.hideText) {
      return (
        <span
          style={{
            display: 'inline-block',
            whiteSpace: 'nowrap',
            width: '80%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {selectedFile.name}
        </span>
      );
    } else {
      return '';
    }
  }
  render() {
    const { showDefaultEyeIcon = true } = this.props;
    const props = this.props;
    const childNode = props.children;
    const elementType = props.componentClass;

    const onChange = (e) => {
      e.target.classList.remove('form-invalid');
      if (
        props.placeholder &&
        props.placeholder.toLowerCase() === 'search here'
      ) {
        if (e.target.value !== '#' && e.target.value !== '&') {
          props.onChange && props.onChange(e);
        }
      } else {
        props.onChange && props.onChange(e);
      }
    };

    const attributes = {
      [props.defaultChecked
        ? 'defaultChecked'
        : 'checked']: props.defaultChecked
        ? props.defaultChecked
        : props.checked,
      ...props,
      onChange,
    };

    if (elementType === 'select') {
      if (props.options) {
        return (
          <SelectWrapper>
            <Select {...attributes}>
              {props.options.map((option, index) => {
                return (
                  <option key={index} value={option.value || ''}>
                    {option.label || ''}
                  </option>
                );
              })}
            </Select>
          </SelectWrapper>
        );
      }
      return (
        <SelectWrapper>
          <Select {...attributes}>{childNode}</Select>
        </SelectWrapper>
      );
    }

    if (elementType === 'radio') {
      if (props.options) {
        return props.options.map((option, index) => {
          return renderElement(
            Radio,
            { key: index, ...attributes, ...option },
            elementType,
            option.childNode
          );
        });
      }

      return renderElement(Radio, attributes, elementType, childNode);
    }

    if (elementType === 'checkbox') {
      return renderElement(Checkbox, attributes, elementType, childNode);
    }

    if (elementType === 'textarea') {
      return <Textarea {...props} />;
    }

    if (elementType === 'timePicker') {
      return (
        <TimePickerStyle>
          <TimeField {...props} className='time-field' />
          <span className='material-symbols-outlined'>schedule</span>
        </TimePickerStyle>
      );
    }

    if (elementType === 'audioPlayer') {
      return (
        <ReactAudioPlayer
          autoPlay={false}
          style={{
            border: 'none',
            width: '100%',
            height: '60px',
            padding: '0px',
            color: '#444',
          }}
          {...props}
        />
      );
    }

    if (elementType === 'audioPlayer30') {
      return (
        <ReactAudioPlayer
          style={{
            border: 'none',
            width: '100%',
            height: '30px',
            padding: '0px',
            color: '#444',
          }}
          {...props}
        />
      );
    }

    if (elementType === 'audioStreamer25') {
      return (
        <audio
          style={{
            border: 'none',
            width: '100%',
            height: '25px',
            padding: '0px',
            color: '#444',
          }}
          controls='controls'
        >
          <source {...props} type='audio/wav' />
        </audio>
      );
    }

    if (elementType === 'audioStreamer') {
      return (
        <audio
          style={{
            border: 'none',
            width: '100%',
            height: '60px',
            padding: '0px',
            color: '#444',
          }}
          controls='controls'
        >
          <source {...props} type='audio/wav' />
        </audio>
      );
    }

    if (elementType === 'toggle') {
      return (
        <div
          style={{
            width: '100%',
            'padding-left': '80%',
            height: '34px',
          }}
        >
          <Toggle
            icons={{
              checked: null,
              unchecked: null,
            }}
            {...props}
          />
        </div>
      );
    }
    if (elementType === 'file') {
      //
      return (
        <SoundGroup>
          <img src='/images/file.png' />
          <span>
            Select or drop a file to upload. <br />
            {this.renderFileName(props.selectedFile)}{' '}
          </span>

          <FileInput {...attributes} />
        </SoundGroup>
      );
    }
    if (elementType === 'user_file') {
      let profileUrl = '/images/avatar-colored.svg';
      if (this.props.profileUrl) {
        profileUrl = this.props.profileUrl;
      } else if (
        this.props.imagePath &&
        props.selectedFile &&
        props.selectedFile.name
      ) {
        profileUrl = `${this.props.imagePath}${props.selectedFile.name}`;
      }
      return (
        <UserProfile>
          {
            <img
              src={profileUrl}
              style={{ width: '100px', height: '100px', marginBottom: '5px' }}
            />
          }
          {this.props.hideText && (
            <span>
              {props.selectedFile
                ? this.renderFileName(props.selectedFile)
                : this.props.hideText
                ? ''
                : 'Select or drop a Profile Pic.'}
            </span>
          )}

          <FileInput {...attributes} />
        </UserProfile>
      );
    }
    let iconStyle = {
      position: 'absolute',
      right: '20px',
    };
    if (elementType === 'inputIcon') {
      // console.log("input icon props ", this.props)
      if (this.props.iconProps && this.props.iconProps.style) {
        iconStyle = {
          ...iconStyle,
          ...this.props.iconProps.style,
        };
      }
      return (
        <div className='d-flex position-relative align-items-center'>
          <Input autocomplete='off' {...attributes} />
          <span
            {...this.props.iconProps}
            style={{ ...iconStyle }}
            className='material-symbols-outlined light-icon icon'
          >
            {this.props.icon}
          </span>
        </div>
      );
    }
    if (
      this.props &&
      this.props.type &&
      this.props.type === 'password' &&
      elementType !== 'inputIcon' &&
      showDefaultEyeIcon === true
    ) {
      return (
        <div className='d-flex position-relative align-items-center'>
          <Input
            autocomplete='off'
            {...attributes}
            type={this.state.visible ? 'text' : 'password'}
          />
          <span
            style={{ ...iconStyle, cursor: 'pointer' }}
            onClick={() => {
              this.setState({ visible: !this.state.visible });
            }}
            className='material-symbols-outlined light-icon icon'
          >
            {this.state.visible ? 'visibility_off' : 'visibility'}
          </span>
        </div>
      );
    }
    // console.log('i am settle the value i am calling the function props : ',attributes)
    return <Input autocomplete='off' {...attributes} />;
  }
} 

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;

export default FormControl;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/form/Control.js